import ajax from '../ajax';

const GENDER_FEMALE = 1;
const GENDER_MALE = 2;
const GENDER_OTHER = 3;

async function fetchClinicPatients() {
    const response = await ajax.get('clinic/patients');
    return response.data;
}

async function fetchAdminPatients(clinicId) {
    const response = await ajax.get(`admin/clinics/${clinicId}/patients`);
    return response.data;
}

export { GENDER_FEMALE, GENDER_MALE, GENDER_OTHER, fetchClinicPatients, fetchAdminPatients };
